class SpeechRecognitionAlternative {
  constructor(transcript, confidence = 1) {
    this.transcript = transcript;
    this.confidence = confidence;
  }
}
export default SpeechRecognitionAlternative;
